(function () {
  'use strict';

  function sortVariantOptions(scope) {
    var context = scope || document;
    context.querySelectorAll('.t4s-product-form__variants .t4s-selector-mode__block .t4s-swatch__list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll(':scope > [data-swatch-item]'));
      if (items.length < 2) return;
      var sortable = items.map(function (item) {
        var match = String(item.dataset.value || '').replace(',', '.').match(/\d+(?:\.\d+)?/);
        return { item: item, value: match ? Number(match[0]) : NaN };
      });
      if (sortable.some(function (entry) { return Number.isNaN(entry.value); })) return;
      sortable.sort(function (a, b) { return a.value - b.value; });
      sortable.forEach(function (entry) { list.appendChild(entry.item); });
    });
  }

  function initPopup(root) {
    if (!root || root.dataset.popupReady === 'true') return;
    root.dataset.popupReady = 'true';

    var dialog = root.querySelector('[data-dread-quiz-dialog]');
    var closeButton = root.querySelector('[data-dread-quiz-popup-close]');
    var lastTrigger = null;
    var closeTimer = null;

    function focusableElements() {
      return Array.prototype.slice.call(dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )).filter(function (element) {
        return element.offsetWidth > 0 || element.offsetHeight > 0;
      });
    }

    function openPopup(trigger) {
      if (closeTimer) window.clearTimeout(closeTimer);
      lastTrigger = trigger || document.activeElement;
      root.hidden = false;
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dread-quiz-popup-open');
      document.body.classList.add('dread-quiz-popup-open');
      root.classList.add('is-open');
      window.setTimeout(function () {
        dialog.scrollTop = 0;
        if (closeButton) closeButton.focus({ preventScroll: true });
      }, 0);
    }

    function closePopup() {
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dread-quiz-popup-open');
      document.body.classList.remove('dread-quiz-popup-open');
      closeTimer = window.setTimeout(function () {
        root.hidden = true;
        if (lastTrigger && typeof lastTrigger.focus === 'function') {
          lastTrigger.focus({ preventScroll: true });
        }
      }, 210);
    }

    function handleDocumentClick(event) {
      var trigger = event.target.closest('[data-dread-quiz-popup-open], a[href="#DreadLocksQuizPopup"]');
      if (!trigger) return;
      event.preventDefault();
      openPopup(trigger);
    }

    function handleRootClick(event) {
      if (event.target.closest('[data-dread-quiz-popup-close]')) closePopup();
    }

    function handleKeydown(event) {
      if (root.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closePopup();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = focusableElements();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener('click', handleDocumentClick);
    document.addEventListener('keydown', handleKeydown);
    root.addEventListener('click', handleRootClick);
  }

  function boot(scope) {
    var context = scope || document;
    sortVariantOptions(context);
    if (context.matches && context.matches('[data-dread-quiz-popup]')) initPopup(context);
    context.querySelectorAll('[data-dread-quiz-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

